import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Col,
  Row,
  message,
  Select,
  DatePicker,
  Button,
  InputNumber,
  Space,
} from "antd";
import {
  API_METHODS,
  BLANK_VALUE,
  DEFAULT_DATE_FORMAT,
} from "../../../constants";
import useApi from "../../../hooks/useApi";
import {
  displayFormattedDate,
  formatDateToDayJS,
  getClientConfig,
  getCreditors,
  isEmpty,
  replaceBlankValueToUndefined,
} from "../../../generalFunctions";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import TableComponent from "../../common/table/TableComponent";
import PrintPdfModal from "../../common/PrintPdfModal";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

function AddDebitNoteBillwise() {
  const innerColumns = [
    {
      title: "Bill Number",
      dataIndex: "billNumber",
    },
    {
      title: "Bill Date",
      dataIndex: "billDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Bill Amount",
      dataIndex: "billAmount",
    },
    {
      title: "Debit Amount",
      dataIndex: "debitAmount",
      render: (text, record) => (
        <InputNumber
          placeholder="Debit Amount"
          onChange={(e) => saveDebitAmount(e, record.id)}
          value={text}
        ></InputNumber>
      ),
    },
    {
      title: "Particulars",
      dataIndex: "particulars",
      render: (text, record) => (
        <Input
          placeholder="Particulars"
          onChange={(e) => saveParticulars(e, record.id)}
          value={text}
        ></Input>
      ),
    },
  ];

  const outerColumns = [
    {
      title: "Bill Number",
      dataIndex: "billNumber",
    },
    {
      title: "Bill Date",
      dataIndex: "billDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Bill Amount",
      dataIndex: "billAmount",
    },
    {
      title: "Debit Amount",
      dataIndex: "debitAmount",
      render: (text) => text,
    },
    {
      title: "Particulars",
      dataIndex: "particulars",
      render: (text) => text,
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => deleteRecord(record)}>
            Delete
          </Button>
        </Space>
      ),
    },
  ];
  const location = useLocation();

  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [visible, setVisible] = useState();
  const [innerTableData, setInnerTableData] = useState();
  const [outerTableData, setOuterTableData] = useState();
  const [debitAmountMaping, setDebitAmountMaping] = useState([]);
  const [particularsMaping, setParticularsMaping] = useState([]);
  const [debitAmountError, setDebitAmountError] = useState();
  const [inititalVals, setInitialVals] = useState();
  const [visiblePrint, setVisiblePrint] = useState(false);

  const [response, request] = useApi(
    "/debitNoteBillwise",
    null,
    API_METHODS.POST
  );
  const [editResponse, editRequest] = useApi(
    `/debitNoteBillwise`,
    null,
    API_METHODS.PUT
  );
  const [billsWithoutDebitNote, getBillsWithoutDebitNote] = useApi(
    "/publicationBill/billWithoutDebitNoteDone",
    null,
    API_METHODS.GET
  );

  const [debitNoteBillwiseData, getDebitNoteBillwiseData] = useApi(
    "/debitNoteBillwise/",
    null,
    API_METHODS.GET
  );

  const [loadingSaveButton, setLoadingSaveButton] = useState(false);

  const { account } = getClientConfig();

  const saveDebitAmount = (e, billId) => {
    const newMapping = [...debitAmountMaping];
    const found = newMapping.findIndex((record) => record.billId === billId);
    if (found === -1) {
      newMapping.push({ billId: billId, debitAmount: e });
    } else {
      newMapping[found].debitAmount = e;
    }
    setDebitAmountMaping(newMapping);
    let newInnerTableData = innerTableData;
    var foundIndex = newInnerTableData.findIndex((data) => data.id == billId);
    newInnerTableData[foundIndex].debitAmount = e;
    setInnerTableData(newInnerTableData);
  };

  const saveParticulars = (e, billId) => {
    const newMapping = [...particularsMaping];
    const found = newMapping.findIndex((record) => record.billId === billId);
    if (found === -1) {
      newMapping.push({ billId: billId, particulars: e.target.value });
    } else {
      newMapping[found].particulars = e.target.value;
    }
    setParticularsMaping(newMapping);
    let newInnerTableData = innerTableData;
    var foundIndex = newInnerTableData.findIndex((data) => data.id == billId);
    newInnerTableData[foundIndex].particulars = e.target.value;
    setInnerTableData(newInnerTableData);
  };

  const deleteRecord = (record) => {
    const selectedBills = outerTableData.filter((bill) => bill !== record);
    let amount = 0;
    let newSelectedRowKeys = selectedRowKeys;

    const index = newSelectedRowKeys.indexOf(record.id);
    if (index > -1) {
      newSelectedRowKeys.splice(index, 1);
    }

    for (let i = 0; i < selectedBills.length; i++) {
      amount = amount + selectedBills[i].debitAmount;
    }
    form.setFieldsValue({ amount });
    setOuterTableData(selectedBills);
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(selectedBills);
  };

  const previousButtonClicked = () => {
    let dnote_id = form.getFieldValue("id") - 1;
    getDebitNoteBillwiseData(
      null,
      API_METHODS.GET,
      `/debitNoteBillwise/${dnote_id}`
    );
  };
  const nextButtonClicked = () => {
    let dnote_id = form.getFieldValue("id") + 1;
    getDebitNoteBillwiseData(
      null,
      API_METHODS.GET,
      `/debitNoteBillwise/${dnote_id}`
    );
  };
  const onFinish = () => {
    form.validateFields().then((values) => {
      if (!loadingSaveButton) {
        setLoadingSaveButton(true);
        values.debitNoteDate = formatDateToDayJS(values.debitNoteDate);
        if (outerTableData && outerTableData.length > 0) {
          values.publicationBillIds = outerTableData.map((bill) => ({
            id: bill.id,
            debitAmount: bill.debitAmount,
            particulars: bill.particulars,
          }));
        }
        if (location && location.state) {
          editRequest(
            values,
            API_METHODS.PUT,
            `/debitNoteBillwise/${location.state.debit_note_id}`
          );
        } else {
          request(values, API_METHODS.POST);
        }
      }
    });
  };

  useEffect(() => {
    const data =
      billsWithoutDebitNote.data !== BLANK_VALUE
        ? billsWithoutDebitNote.data
        : [];
    setInnerTableData(data);
  }, [billsWithoutDebitNote]);

  useEffect(() => {
    if (editResponse.data) {
      message.success("Debit Note Billwise updated successfully.");
      setLoadingSaveButton(false);
      navigate("/portal/debitNoteBillwise");
    }
  }, [editResponse]);

  useEffect(() => {
    if (response.data) {
      message.success("Debit Note Billwise added successfully.");
      setLoadingSaveButton(false);
      navigate("/portal/debitNoteBillwise");
    }
  }, [response]);

  useEffect(() => {
    if (location.state && location.state.debit_note_id) {
      getDebitNoteBillwiseData(
        null,
        API_METHODS.GET,
        `/debitNoteBillwise/${location.state.debit_note_id}`
      );
    }
  }, [location.state]);

  useEffect(() => {
    let initialValues =
      debitNoteBillwiseData &&
      debitNoteBillwiseData.data &&
      debitNoteBillwiseData.data[0];
    if (initialValues) {
      initialValues = replaceBlankValueToUndefined(initialValues);
      initialValues.debitNoteDate = formatDateToDayJS(
        initialValues.debitNoteDate
      );
      form.setFieldsValue(initialValues);
      getBillsWithoutDebitNote(
        null,
        API_METHODS.GET,
        `/publicationBill/billWithoutDebitNoteDone/${initialValues.creditorId}`
      );

      setInitialVals(initialValues);
      setOuterTableData(initialValues.billData);
      let keys = [];
      for (let i = 0; i < initialValues.billData.length; i++) {
        keys.push(initialValues.billData[i].publicationBillId);
      }
      setSelectedRows(initialValues.billData);
      setSelectedRowKeys(keys);
    } else if (debitNoteBillwiseData.error) {
      navigate("/portal/debitNoteBillwise");
    }
  }, [debitNoteBillwiseData]);

  const creditorChanged = (creditorId) => {
    getBillsWithoutDebitNote(
      null,
      API_METHODS.GET,
      `/publicationBill/billWithoutDebitNoteDone/${creditorId}`
    );

    if (location.state && creditorId === inititalVals.creditorId) {
      let keys = [];
      for (let i = 0; i < inititalVals.billData.length; i++) {
        keys.push(inititalVals.billData[i].id);
      }
      setOuterTableData(inititalVals.billData);
      setSelectedRows(inititalVals.billData);
      setSelectedRowKeys(keys);
      form.setFieldsValue(inititalVals);
    } else {
      setOuterTableData();
      setSelectedRows([]);
      setSelectedRowKeys([]);
      form.setFieldsValue({
        amount: 0,
      });
    }
  };

  const onRowSelectChange = (newSelectedRowKeys, records) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(records);
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    onChange: onRowSelectChange,
  };

  const setModalVisible = () => {
    setVisible(true);
  };

  const cancel = () => {
    setDebitAmountError(null);
    setVisible(false);
  };

  const billsSelected = () => {
    let amount = 0;
    let newSelectedRows = [...selectedRows];
    if (newSelectedRows) {
      if (!isEmpty(outerTableData)) {
        newSelectedRows = [...new Set([...outerTableData, ...selectedRows])];
      }

      let debitAmountError;
      for (let i = 0; i < newSelectedRows.length; i++) {
        debitAmountError =
          isEmpty(newSelectedRows[i].debitAmount) ||
          isEmpty(newSelectedRows[i].particulars)
            ? "Debit Amount And Particulars are required."
            : null;
        setDebitAmountError(debitAmountError);
        if (debitAmountError) return;
      }
      if (isEmpty(debitAmountError)) {
        for (let i = 0; i < newSelectedRows.length; i++) {
          amount = amount + newSelectedRows[i].debitAmount;
        }
        form.setFieldsValue({
          amount,
        });
        setOuterTableData(newSelectedRows);
        setVisible(false);
      }
    }
  };

  const handlePrint = () => {
    const flag = visiblePrint ? false : true;
    setVisiblePrint(flag);
  };

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        disabled={location && location.state && location.state.isViewOnly}
        initialValues={{
          debitNoteDate: dayjs(),
        }}
        onFinish={onFinish}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="debitNoteDate"
              label="Debit Note Date"
              rules={[
                { required: true, message: "Debit Note Date is required." },
              ]}
            >
              <DatePicker format={DEFAULT_DATE_FORMAT} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="creditorId"
              label="Creditor"
              rules={[{ required: true, message: "Creditor is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                onSelect={creditorChanged}
              >
                {getCreditors(account).map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.accountName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {form.getFieldValue("creditorId") && (
          <Button type="primary" onClick={setModalVisible}>
            Select Publication Bills
          </Button>
        )}{" "}
        {outerTableData && outerTableData.length > 0 && (
          <TableComponent
            columns={outerColumns}
            tableData={outerTableData}
            clientSideRender={true}
          />
        )}
        <Modal
          title="Select Publication Bills"
          open={visible}
          onOk={billsSelected}
          onCancel={cancel}
          width={1000}
          okText="Save"
          destroyOnClose={true}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            {debitAmountError && (
              <span style={{ color: "red" }}>* {debitAmountError}</span>
            )}
            <TableComponent
              rowKey="id"
              columns={innerColumns}
              tableData={innerTableData}
              rowSelection={rowSelection}
              clientSideRender={true}
            />
          </Space>
        </Modal>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="narration"
              label="Narration"
              rules={[
                { required: true, message: "Narration is required." },
                {
                  max: 100,
                  message: "Narration should be maximum of 100 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Amount" name="amount">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loadingSaveButton}
              >
                Save
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Button
              type="default"
              onClick={() => {
                navigate("/portal/debitNoteBillwise");
              }}
              disabled={false}
            >
              {location && location.state && location.state.isViewOnly
                ? "Close"
                : "Cancel"}
            </Button>
          </Col>
          {location && location.state && location.state.isViewOnly && (
            <Col>
              <Form.Item>
                <Button type="primary" onClick={handlePrint} disabled={false}>
                  Print
                </Button>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
      {location && location.state &&  location.state.isViewOnly &&(
        <Row justify="space-between">
          <Button type="primary" onClick={previousButtonClicked}>
            <LeftOutlined />
            Previous
          </Button>
          <Button type="primary" onClick={nextButtonClicked}>
            Next
            <RightOutlined />
          </Button>
        </Row>
      )}

      {visiblePrint && (
                <PrintPdfModal
                    visible={visiblePrint}
                    data={[inititalVals]}
                    title={"Debit Note"}
                    close={handlePrint}
                    pdfType="debitNoteBillwise"
                />
            )}
    </>
  );
}

export default AddDebitNoteBillwise;
